<template>
  <div class="home">
    <v-row>
      <v-col cols="10">
        <h2 class="text-right d-flex justify-start mt-5">Escolha a Empresa</h2>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
          class="text-field-uppercase"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider class="mb-5"></v-divider>
    <v-row class="justify-center">
      <v-col
        cols="12"
        xs="12"
        md="12"
        v-if="filterSearch(columns.for).length > 0"
      >
        <v-row>
          <v-col>
            <h2 class="text-center d-flex justify-center">Fornecedores</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            xs="12"
            md="4"
            v-for="item in filterSearch(columns.for)"
            :key="item.id"
          >
            <v-card class="mx-4 py-6" max-width="600">
              <v-card-text>
                <p class="text-center">
                  <v-chip label :color="getColorType(item.type)" dark>
                    {{ getLabelType(item.type) }}
                  </v-chip>
                </p>
                <p
                  class="subtitle-1 mt-5 text--primary text-center"
                  v-if="item.type === 'for'"
                >
                  {{ item.code }} - {{ item.description }}
                </p>
                <p class="subtitle-1 mt-5 text--primary text-center" v-else>
                  {{ item.code }} - {{ item.name }}
                </p>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  outlined
                  color="deep-purple accent-4"
                  @click="handleSelectCompany(item)"
                >
                  Selecionar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        md="12"
        v-if="filterSearch(columns.fra).length > 0"
      >
        <v-row>
          <v-col>
            <h2 class="text-center d-flex justify-center">Franquias</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            xs="12"
            md="4"
            v-for="item in filterSearch(columns.fra)"
            :key="item.id"
          >
            <v-card class="mx-4 py-6" max-width="600">
              <v-card-text>
                <p class="text-center">
                  <v-chip label :color="getColorType(item.type)" dark>
                    {{ getLabelType(item.type) }}
                  </v-chip>
                </p>
                <p
                  class="subtitle-1 mt-5 text--primary text-center"
                  v-if="item.type === 'for'"
                >
                  {{ item.code }} - {{ item.description }}
                </p>
                <p class="subtitle-1 mt-5 text--primary text-center" v-else>
                  {{ item.code }} - {{ item.name }}
                </p>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  outlined
                  color="deep-purple accent-4"
                  @click="handleSelectCompany(item)"
                >
                  Selecionar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        md="12"
        v-if="filterSearch(columns.mul).length > 0"
      >
        <v-row>
          <v-col>
            <h2 class="text-center d-flex justify-center">Multimarcas</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            xs="12"
            md="4"
            v-for="item in filterSearch(columns.mul)"
            :key="item.id"
          >
            <v-card class="mx-4 py-6" max-width="600">
              <v-card-text>
                <p class="text-center">
                  <v-chip label :color="getColorType(item.type)" dark>
                    {{ getLabelType(item.type) }}
                  </v-chip>
                </p>
                <p
                  class="subtitle-1 mt-5 text--primary text-center"
                  v-if="item.type === 'for'"
                >
                  {{ item.code }} - {{ item.description }}
                </p>
                <p class="subtitle-1 mt-5 text--primary text-center" v-else>
                  {{ item.code }} - {{ item.name }}
                </p>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  outlined
                  color="deep-purple accent-4"
                  @click="handleSelectCompany(item)"
                >
                  Selecionar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!--   <v-col>
        <v-card class="mx-auto" max-width="600">
          <v-card-text>
            <div>HISTORICO DE PEDIDOS</div>
            <p class="text-h4 text--primary">PEDIDOS</p>
            <p>EM ABERTO</p>
            <div class="text--primary">
              AQUI PODE VIM UM GRÁFICO OU RELATÓRIO MOSTRANDO ALGUMA INFORMAÇÃO
              IMPORTANTE DE PEDIDOS
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="deep-purple accent-4"> SAIBA MAIS </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto" max-width="600">
          <v-card-text>
            <div>ROYALTIES A PAGAR</div>
            <p class="text-h4 text--primary">ROYALTIES</p>
            <p>07/10/2021</p>
            <div class="text--primary">
              DETALHAMENTO DE COBRANÇA OU ALGUMA OUTRA INFORMAÇÃO IMPORTANTE
              <br />
              <br />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="deep-purple accent-4"> SAIBA MAIS </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import * as HTTP from "@/api/requests/base";

export default {
  name: "ChooseCompany",
  data: () => ({
    user: {
      id: "",
      name: "",
      companies: [],
    },
    columns: {
      fra: [],
      for: [],
    },
    search: "",
  }),
  components: {},
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getNameForSessionStorage();
    },
    getNameForSessionStorage() {
      let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
      if (session) {
        session = JSON.parse(session);
        if (session.user !== "") {
          this.user = session.user;
          this.user.companies = this.user.companies.sort((a, b) =>
            a.name > b.name ? 1 : -1
          );
          this.columns.fra = this.user.companies.filter(
            (item) => item.type === "fra"
          );
          this.columns.for = this.user.companies.filter(
            (item) => item.type === "for"
          );
          this.columns.mul = this.user.companies.filter(
            (item) => item.type === "mul"
          );
          console.log(this.columns);
        }
      }
    },
    getColorType(type) {
      console.log(type);
      if (type === "fra") {
        return "blue darken-4";
      } else if (type === "for") {
        return "brown lingthen-1";
      } else {
        return "orange darken-3";
      }
    },
    getLabelType(type) {
      if (type === "fra") {
        return "Franquia";
      } else if (type === "for") {
        return "Fornecedor";
      } else {
        return "Multimarcas";
      }
    },
    handleSelectCompany(item) {
      let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
      if (session) {
        session = JSON.parse(session);
        session.company_selected = item;
        localStorage.setItem(
          HTTP.COMMON_LOCAL_STORAGE_KEY,
          JSON.stringify(session)
        );
      }
      this.$router.push({ name: "Home" });
    },
    filterSearch(data) {
      if (this.search == "") {
        return data;
      }
      if (data.length === 0) {
        return data;
      }
      const searchString = this.search.toString().toUpperCase();
      return data.filter(
        (item) =>
          item.name.includes(searchString) ||
          item.description.includes(searchString) ||
          item.code.includes(searchString)
      );
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
